import SlectionContainer from './accordion';

export default SlectionContainer;
